(function () {
  'use strict';

  function initPairingSlider(wrapper) {
    const track = wrapper.querySelector('.pdp-pairing__track');
    const prev = wrapper.querySelector('.pdp-pairing__nav--prev');
    const next = wrapper.querySelector('.pdp-pairing__nav--next');
    if (!track || !prev || !next) return;

    function getStep() {
      const card = track.querySelector('.pdp-pairing__card');
      if (!card) return 260;
      const styles = getComputedStyle(track);
      const gap = parseFloat(styles.columnGap || styles.gap) || 16;
      return card.offsetWidth + gap;
    }

    function updateNavState() {
      const maxScroll = track.scrollWidth - track.clientWidth;
      prev.disabled = track.scrollLeft <= 1;
      next.disabled = maxScroll <= 0 || track.scrollLeft >= maxScroll - 1;
    }

    prev.addEventListener('click', function () {
      track.scrollBy({ left: -getStep(), behavior: 'smooth' });
    });

    next.addEventListener('click', function () {
      track.scrollBy({ left: getStep(), behavior: 'smooth' });
    });

    track.addEventListener('wheel', function (e) {
      if (Math.abs(e.deltaX) >= Math.abs(e.deltaY)) return;
      if (e.deltaY === 0) return;

      const maxScroll = track.scrollWidth - track.clientWidth;
      const atStart = track.scrollLeft <= 0;
      const atEnd = track.scrollLeft >= maxScroll;

      if ((e.deltaY > 0 && atEnd) || (e.deltaY < 0 && atStart)) return;

      e.preventDefault();
      track.scrollLeft += e.deltaY;
    }, { passive: false });

    track.addEventListener('scroll', updateNavState, { passive: true });
    window.addEventListener('resize', updateNavState);
    updateNavState();
  }

  function init() {
    const wrappers = document.querySelectorAll('.pdp-pairing__track-wrapper');
    wrappers.forEach(initPairingSlider);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
